import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import i18n from 'i18n-js';

export const subathonFeaturedContent = {
  description: (
    <>
      <Box>
        <Typography variant="h6" as="span" mr={1}>
          {i18n.t(
            'screens.dashboard.subathonFeaturedContent.description1.main'
          )}
        </Typography>
        <Typography as="span" color="#E5E5FF" variant="body2">
          {i18n.t(
            'screens.dashboard.subathonFeaturedContent.description1.secondary'
          )}
        </Typography>
      </Box>
      <Box>
        <Typography variant="h6" as="span" mr={1}>
          {i18n.t(
            'screens.dashboard.subathonFeaturedContent.description2.main'
          )}
        </Typography>
        <Typography as="span" color="#E5E5FF" variant="body2">
          {i18n.t(
            'screens.dashboard.subathonFeaturedContent.description2.secondary'
          )}
        </Typography>
      </Box>
      <Box>
        <Typography variant="h6" as="span" mr={1}>
          {i18n.t(
            'screens.dashboard.subathonFeaturedContent.description3.main'
          )}
        </Typography>
        <Typography as="span" color="#E5E5FF" variant="body2">
          {i18n.t(
            'screens.dashboard.subathonFeaturedContent.description3.secondary'
          )}
        </Typography>
      </Box>
    </>
  ),
  img: {
    imgAlt: i18n.t('screens.dashboard.subathonFeaturedContent.title'),
    imgUrl:
      'https://overlayon.s3.eu-west-3.amazonaws.com/subathon-featured-card.png',
  },
  subtitle: (
    <Box sx={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
      <Typography variant="h6" as="span">
        {i18n.t('screens.dashboard.subathonFeaturedContent.subtitle')}
      </Typography>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.12505 0.400391L0.800049 3.92539V17.2004H5.20005V19.6004H8.16255L10.5625 17.2004H14.1625L19.2 12.1754V0.400391H2.12505ZM4.40005 2.40039H17.2V11.2004L14.8 13.6004H10L7.60005 16.0004V13.6004H4.40005V2.40039ZM8.00005 5.20039V10.8004H10.4V5.20039H8.00005ZM12 5.20039V10.8004H14.4V5.20039H12Z"
          fill="white"
        />
      </svg>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.9593 5.79961C17.8 4.91992 17.0406 4.2793 16.1593 4.0793C14.8406 3.79961 12.4 3.59961 9.75933 3.59961C7.12026 3.59961 4.64058 3.79961 3.32026 4.0793C2.44058 4.2793 1.67964 4.8793 1.52026 5.79961C1.35933 6.79961 1.19995 8.19961 1.19995 9.99961C1.19995 11.7996 1.35933 13.1996 1.55933 14.1996C1.72026 15.0793 2.47964 15.7199 3.35933 15.9199C4.75933 16.1996 7.15933 16.3996 9.79995 16.3996C12.4406 16.3996 14.8406 16.1996 16.2406 15.9199C17.1203 15.7199 17.8796 15.1199 18.0406 14.1996C18.2 13.1996 18.4 11.759 18.4406 9.99961C18.3593 8.19961 18.1593 6.79961 17.9593 5.79961ZM7.59995 12.7996V7.19961L12.4796 9.99961L7.59995 12.7996Z"
          fill="white"
        />
      </svg>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7846 10.403L14.1461 10.293C13.3384 10.293 12.4231 10.5681 11.7231 11.2284C10.8077 12.1087 10.7 13.5393 11.0769 14.4746C11.4538 15.41 12.5307 15.9602 13.6077 15.7401C14.4692 15.5751 14.9 14.7497 14.8461 14.0345C14.7923 13.4292 14.4154 13.0991 13.9846 13.0991C13.5538 13.0991 13.3923 13.3192 13.3384 13.5393C13.2846 13.7594 13.3923 13.9244 13.5538 14.0345C13.8231 14.2546 13.3384 14.9148 12.7461 14.5297C12.4231 14.3096 12.1538 13.8144 12.2077 13.2091C12.3154 12.3838 12.9615 11.6135 14.1461 11.6135C15.3846 11.6135 16.2461 12.3838 16.5154 13.5393C16.8923 14.9698 16.1384 16.7305 14.4154 17.6659C12.3154 18.8213 8.76151 18.7113 6.82305 16.6205C5.69228 15.41 5.31536 13.8144 5.42305 12.3288C5.4769 11.8336 5.53074 11.3384 5.63844 10.8432C5.69228 10.6782 5.58459 10.5131 5.36921 10.4581H5.31536H2.03075C1.81536 10.4581 1.59998 10.293 1.59998 10.0179C1.59998 9.96288 1.59998 9.96288 1.59998 9.90786L2.62305 5.39609C2.6769 5.12099 2.94613 4.9009 3.21536 4.9009H6.66151C6.82305 4.9009 6.98459 4.79086 7.03844 4.62579L7.5769 2.03978C7.63074 1.76467 7.89998 1.59961 8.11536 1.59961H12.8538C13.0692 1.59961 13.2307 1.76467 13.2307 1.98476C13.2307 2.03978 13.2307 2.03978 13.2307 2.0948L12.7461 4.68081C12.7461 4.79086 12.8 4.9009 12.9077 4.9009H12.9615H18.0231C18.2384 4.9009 18.4 5.06596 18.4 5.34107C18.4 5.39609 18.4 5.39609 18.4 5.45111L17.2692 9.96288C17.1615 10.293 17 10.4581 16.7846 10.403Z"
          fill="white"
        />
      </svg>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99995 1.2002C5.13995 1.2002 1.19995 5.1402 1.19995 10.0002C1.19995 14.4122 4.44995 18.055 8.68475 18.6914V12.3326H6.50755V10.0194H8.68475V8.4802C8.68475 5.9318 9.92635 4.813 12.0444 4.813C13.0588 4.813 13.5952 4.8882 13.8492 4.9226V6.9418H12.4044C11.5052 6.9418 11.1912 7.7942 11.1912 8.755V10.0194H13.8264L13.4688 12.3326H11.1912V18.7102C15.4864 18.1274 18.8 14.455 18.8 10.0002C18.8 5.1402 14.86 1.2002 9.99995 1.2002Z"
          fill="white"
        />
      </svg>
    </Box>
  ),
  title: i18n.t('screens.dashboard.subathonFeaturedContent.title'),
};
